import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "App-Reset-Succ",
  "txt-center": ""
}
const _hoisted_2 = {
  "txt-center": "",
  style: {"min-height":"60px","padding":"10px 20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        lazy: "",
        style: `width: 200px;`,
        src: _ctx.img
      }, null, 8, ["src"])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("h2", {
      "m-tb-0": "",
      "txt-center": ""
    }, [
      _createTextVNode(" Password Resetted "),
      _createElementVNode("br"),
      _createTextVNode(" successfully! ")
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { "m-tb-0": "" }, "Now you can sign in!", -1))
  ]))
}